import { Injectable } from '@angular/core';
import { Person } from '../../shared/models';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { PersonService } from '../../core/data-services/person.service';
import { map } from 'rxjs/operators';
import { PERMISSIONS } from '../../shared/enums/permissions.enum';
import { AuthorizationService } from '../../core/services';

@Injectable({
  providedIn: 'root'
})
export class RestrictionsIntegrationService {

  public readonly boardRoles = [
    'Director',
    'Observer',
    'Independent Director',
    'Chairman of the Board',
    'SAB'
  ];

  public hasRestrictionPermission: Partial<Record<PERMISSIONS, boolean>> = {
    [PERMISSIONS.TradeRestrictionRead]: false,
    [PERMISSIONS.TradeRestrictionLimitedRead]: false,
    [PERMISSIONS.TradeRestrictionCreate]: false,
    [PERMISSIONS.TradeRestrictionUpdate]: false,
    [PERMISSIONS.TradeRestrictionDelete]: false,
    [PERMISSIONS.BoardRestrictionRead]: false,
    [PERMISSIONS.BoardRestrictionCreate]: false,
    [PERMISSIONS.BoardRestrictionUpdate]: false,
    [PERMISSIONS.BoardRestrictionDelete]: false
  }

  private peopleObs$: Subject<Array<Person>> = new BehaviorSubject<Array<Person>>([]);
  private _boardSeatUpdateObs$: Subject<Array<number>> = new Subject<Array<number>>();

  constructor(
    private personService: PersonService,
    private readonly authorizationService: AuthorizationService,
  ) {
    this.getPeople();
    this.setPermissions();
  }

  private getPeople() {
    this.personService.getPeople({pagesize: 9999}).pipe(
      map(resp => resp.records
        .map(p => new Person(p))
        .sort((a, b) => a.fullName.localeCompare(b.fullName)))
    ).subscribe(resp => {
      this.peopleObs$.next(resp);
    });
  }

  private setPermissions() {
    for (const permission of Object.keys(this.hasRestrictionPermission)) {
      this.hasRestrictionPermission[permission] = this.authorizationService.hasPermission([permission]);
    }
  }

  get people(): Observable<Array<Person>> {
    return this.peopleObs$;
  }

  get boardSeatUpdate$(): Subject<Array<number>> {
    return this._boardSeatUpdateObs$;
  }

  set boardSeatUpdate$(value: Subject<Array<number>>) {
    this._boardSeatUpdateObs$ = value;
  }
}
